import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import ConfigService from '../../../api/services/ConfigService';
import { RootState } from '../../../store';
import { generateBoilerplateAsyncThunkMatchers } from '../../../store/helpers';
import { CommonDropdownType } from '../../../types';

const ACTIONS_PREFIX = 'config_values';

type ConfigValueProps = {
  configValues: CommonDropdownType[] | null;
  isLoading: boolean;
};

const initialState: ConfigValueProps = {
  configValues: [],
  isLoading: false,
};

export const getConfigValues = createAsyncThunk(
  `${ACTIONS_PREFIX}/getValues`,
  async ({ serviceType, configType = 'picker' }: { serviceType: string; configType?: string }) => {
    return ConfigService.getConfigValues(serviceType, configType);
  },
);
const configValueSlice = createSlice({
  name: 'configValues',
  initialState,
  reducers: {
    clearConfigValues: (state) => {
      state.configValues = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getConfigValues.fulfilled, (state, action) => {
      state.configValues = action.payload?.resource?.[0].config_value;
    });
    generateBoilerplateAsyncThunkMatchers<ConfigValueProps>(builder, ACTIONS_PREFIX);
  },
});

export const selectConfigValueState = (state: RootState) => state.configValues;

export default configValueSlice.reducer;
